import Noteify from "../assets/projects/noteify.png";
import Newsbite from "../assets/projects/newsbite.png";
import Blogsnow from "../assets/projects/blogsnow.png";
import Netflix from "../assets/projects/netflix.png";
import Searchify from "../assets/projects/searchify.png";
import Geargo from "../assets/projects/geargo.png";

export const data = [
  {
    id: 1,
    name: "Searchify",
    image: Searchify,
    github: "https://github.com/jayantghadge/searchify",
    live: "https://searchify-jayantghadge.vercel.app",
  },
  {
    id: 2,
    name: "GearGo",
    image: Geargo,
    github: "https://github.com/jayantghadge/GearGo",
    live: "https://gear-go-jg.onrender.com",
  },
  {
    id: 3,
    name: "Netflix",
    image: Netflix,
    github: "https://github.com/jayantghadge/netflix-reactJs",
    live: "https://netflix-react-js-jayantghadge.vercel.app",
  },
  {
    id: 4,
    name: "Newsbite",
    image: Newsbite,
    github: "https://github.com/jayantghadge/NewsBite",
    live: "https://news-bite-jayantghadge.vercel.app",
  },
  {
    id: 5,
    name: "Noteify",
    image: Noteify,
    github: "https://github.com/jayantghadge/noteify",
    live: "https://noteify-jayantghadge.vercel.app",
  },
  {
    id: 6,
    name: "Blogsnow",
    image: Blogsnow,
    github: "https://github.com/jayantghadge/Blognow",
    live: "https://blognow-co4m-jayantghadge.vercel.app/",
  },
];
